
// 9

exports.validate = (arr,tableType) => {
  const errors = [];
  for (let i = 0; i < arr.length; i++) {
    for (let j = 0; j < arr[0].length; j++) {
      const element = arr[i][j];
      if(element.enabled === false) continue;
      const from = parseInt(element.from);
      const to = parseInt(element.to);
      if (from > to) {
        const message =
          "Please check your measurement ranges and make sure that the minimum value is on the left and the maximum value is on the right.";
        errors.push({ coordinate: [i, j], message,tableType});
      }
    }
  }

  return errors;
};
